import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jgv6czey3x: FaireBrandEntity = {
  token: "b_jgv6czey3x",
  type: "brand",
  name: "Tiny Revival Clothing Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/bd5872e175bc9b9fc0c934a616cb1bef7aa0be7a16e290eb3668bfa47dae9ab9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a7d67bcb20969ea88fc22d61f8b71cc0ca52f47290a50fc75b342b567133816f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bd5872e175bc9b9fc0c934a616cb1bef7aa0be7a16e290eb3668bfa47dae9ab9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a7d67bcb20969ea88fc22d61f8b71cc0ca52f47290a50fc75b342b567133816f.jpeg",
  location: "Salisbury, NC, USA",
  minimumOrderDollars: 350,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "Tiny Revival creates faith-filled children’s clothing designed to tell timeless stories and make a lasting impact.\n\nEach piece is thoughtfully handcrafted using sustainable, ultra-soft Organic Bamboo Lyocell, chosen for its comfort, durability, and gentleness on sensitive skin. Our collections are inspired by Scripture and biblical stories, turning everyday moments—bedtime, playtime, family traditions—into meaningful reminders of faith.\n\nWe partner with skilled artisans who are paid fair wages and work in ethical conditions, and with every purchase, we give back to organizations fighting human trafficking. When families choose Tiny Revival, they’re not just dressing their children—they’re participating in restoration, dignity, and hope.\n\nTiny Revival is clothing with a purpose, created to be worn, loved, and passed down.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:05.767Z",
    importedBy: "entity-db-cli",
  },
};
